import React from 'react';
import PropTypes from 'prop-types';

const UserAvatarIcon = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="User avatar"
  >
    <circle cx="12" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6 19C6.8 16.6 9.16 15 12 15C14.84 15 17.2 16.6 18 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

UserAvatarIcon.propTypes = {
  className: PropTypes.string
};

UserAvatarIcon.defaultProps = {
  className: ''
};

export default UserAvatarIcon;
